module.exports = __webpack_public_path__ + "img/road-disabled.e1bd0880.jpg";